// Auto-generated by devextreme-license.
// Do not commit this file to source control.

export const licenseKey = 'LCPv177yfSj+jSR<nV+eGc7+fe%,6,Y,QV<4yZ>%4ZjFd3YS_Vid-7R,e(N%@pnS@2+a;e<4::n-+Io,RI<t7ci%89LLJcytQ:jVk>LyR3i!K>Jyee+-RSi:zpLeKI<-8!jV_(>QBp<S_!LaY!YVgcjF4pRX[eQDneY,n:_4$INV+2N,<2%Xo%Ncmk7z-SQ-vIR+6pL!)py+$2<d)9K9B6_yESQ-:pK-v6LX;>%X<2p@@!Q462b-v2%d)I<-@aQd@pg@@!Q4@2_@F!Qd:Ip!@I<4)aKz<I_y62%d6p<X<aN-@>Q4:>Q8vIbR)9jz;!jL;9jyFI7yFI7yFI9ll';
